'use client';

import { AttackerEditModal } from '../../tools/attacker/attacker-edit-modal';
import { attackerHitlConfig } from '../../tools/attacker/hitl-config';
import type { AttackerToolInput } from '../../tools/attacker/types';

type AttackerEditModalWrapperProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (editedArgs: Record<string, unknown>) => void;
  toolName?: string;
  extractedData?: unknown[];
};

function parseAttackerData(data: unknown): AttackerToolInput {
  if (!data || typeof data !== 'object') {
    return { signalId: '', userAttackPrompt: '' };
  }

  const input = data as Record<string, unknown>;

  return {
    signalId: String(input.signalId || ''),
    endpointId: input.endpointId ? String(input.endpointId) : undefined,
    harEntryId: input.harEntryId ? String(input.harEntryId) : undefined,
    credentialId: input.credentialId ? String(input.credentialId) : undefined,
    userNotes: input.userNotes ? String(input.userNotes) : undefined,
    userAttackPrompt: String(input.userAttackPrompt || ''),
  };
}

export function AttackerEditModalWrapper({
  isOpen,
  onClose,
  onSubmit,
  toolName,
  extractedData = [],
}: AttackerEditModalWrapperProps) {
  const hitlConfig = attackerHitlConfig;

  const handleSubmit = (editedData: AttackerToolInput) => {
    if (!hitlConfig) return;
    const wrappedData = hitlConfig.wrapEditedData([editedData]);
    onSubmit(wrappedData);
    onClose();
  };

  if (!isOpen || extractedData.length === 0) return null;

  // Parse the first item (attacker-tool only has one input)
  const attackerData = parseAttackerData(extractedData[0]);

  return (
    <AttackerEditModal
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={handleSubmit}
      data={attackerData}
      actionName={toolName}
    />
  );
}
